import BaseService from '../../services/BaseService';

class ResetPasswordService extends BaseService {
    resetPasswordFirstStep = (data) => this.post('/forgot-password-request', data);

    verifyForgotPasswordOtp = (data) => this.post('/verify-forgot-password-otp', data);

    verifyEmail = (data) => this.post('/verify-email-otp', data);

    resetPasswordThirdStep = (data) => this.post('/reset-password', data);

    resetPasswordResendOtp = (data) => this.post('/resend-forgot-password-otp', data);

    resendVerifyEmailOtp = (data) => this.post('/resend-verify-email-otp', data);
}

export default new ResetPasswordService();
